import React from 'react';

import { Box } from '@bcp-nextgen-dx-component-factory/design-system';
import { DisplayGroupProps } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { ComponentInfo, DisplayGroupRender } from '@components';
import { LEFT_PANEL_WIDTH } from '@constants';
import { rem } from '@helpers';

export const BodyPanelForms: React.FC<DisplayGroupProps> = (props: DisplayGroupProps) => {
	return (
		<ComponentInfo
			name="BodyPanel"
			type="displayGroup"
			as={Box}
			styles={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				flexGrow: 1,
				width: `calc(100vw - ${rem(LEFT_PANEL_WIDTH)})`,
			}}
		>
			<DisplayGroupRender displayGroupsProps={props} />
		</ComponentInfo>
	);
};
